import "antd/es/select/style";
import _Select from "antd/es/select";
import "antd/es/pagination/style";
import _Pagination from "antd/es/pagination";
import "antd/es/table/style";
import _Table from "antd/es/table";
import "antd/es/col/style";
import _Col from "antd/es/col";
import "antd/es/row/style";
import _Row from "antd/es/row";
import "antd/es/popover/style";
import _Popover from "antd/es/popover";
import "antd/es/checkbox/style";
import _Checkbox from "antd/es/checkbox";
import "antd/es/space/style";
import _Space from "antd/es/space";
var _excluded = ["total", "page", "pageSize", "pageSizeOptions", "columns", "dataSource", "actionButtons", "className", "extraButtons", "filterConfig", "actionButtonsFilter", "colMax", "noCustomize", "onRow", "onClickRow", "onPagination", "colDisable", "bottomExtra", "rowClassName", "rowSelection", "noPagination", "style", "locale"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import invariant from 'invariant';
import moment from 'moment';
import { useState, useRef, useContext, useEffect, useReducer } from 'react';
import Button from '../button';
import { LocaleContext } from '../locale';
import Typography from '../typography';
import Modal from '../modal/index';
import Filter from '../filter/index';
import './style/index.less';
import { SettingOutlined, DotMenuOutlined, ArrowDownOutlined, ArrowLeftOutlined, ArrowRightOutlined } from 'iglooicon';
import classNames from 'classnames';

var headerStyle = function headerStyle() {
  return {
    style: {
      color: 'white'
    }
  };
};

var filterDefaultShow = function filterDefaultShow(col) {
  return col.filter(function (item) {
    return item.defaultShow !== false && item.customize !== false;
  }).map(function (item) {
    return item.key;
  });
}; // buttons:all actionButtons, rowData:current row record data, actionButtonsFilter: filter function


var getDropDownMenu = function getDropDownMenu(allButtons, rowData, actionButtonsFilter, setActionListVisible, actionIndex) {
  var actionButtons = actionButtonsFilter && typeof actionButtonsFilter === 'function' ? actionButtonsFilter(rowData, allButtons) : allButtons;
  return _jsx(_Space, {
    size: 16,
    style: {
      padding: '4px 8px'
    },
    direction: "vertical",
    children: actionButtons.map(function (item, index) {
      return _jsx(Button, {
        type: "text",
        onClick: function onClick(e) {
          e.stopPropagation();
          item.onClick(rowData);
          setActionListVisible({
            type: actionIndex,
            value: false
          });
        },
        children: _jsx(Typography, {
          level: "body1",
          children: item.text
        })
      }, index);
    })
  }, actionIndex);
};

function handleFilterDisable() {
  var all = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var disable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (disable.length === 0) {
    return all;
  }

  return all.filter(function (item) {
    return !disable.includes(item);
  });
}

function getDefaultOptions(params) {
  return params.reduce(function (res, item) {
    var key = item.key,
        defaultChoosed = item.default,
        _item$disabled = item.disabled,
        disabled = _item$disabled === void 0 ? [] : _item$disabled,
        type = item.type,
        disabledDate = item.disabledDate; // 判定一下默认时间在不在 不可选时间中

    if (type === 'date' && typeof disabledDate === 'function' && defaultChoosed && defaultChoosed.length) {
      // 判定的时候需要以 '天'作为最小单位
      var begin = moment(defaultChoosed[0]).endOf('day');
      var end = moment(defaultChoosed[1]).endOf('day');
      invariant(!disabledDate(begin) && !disabledDate(end), 'The default date is within a non-selectable time range');
    }

    if (type === 'single') {
      invariant(_typeof(defaultChoosed) !== 'object', 'The radio default value can not be a object');
      invariant(disabled.indexOf(defaultChoosed) === -1, 'The default value cannot be in the non-selectable range');
      return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, defaultChoosed));
    }

    return defaultChoosed ? _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, handleFilterDisable(defaultChoosed, disabled))) : res;
  }, {});
}

function paginationItem(page, type, originalElement) {
  if (type === 'prev') {
    return _jsx(ArrowLeftOutlined, {
      style: {
        fontSize: 24,
        marginRight: 8,
        verticalAlign: 'middle'
      },
      className: "ant-btn-link"
    });
  }

  if (type === 'next') {
    return _jsx(ArrowRightOutlined, {
      style: {
        fontSize: 24,
        verticalAlign: 'middle'
      },
      className: "ant-btn-link"
    });
  }

  return _jsx("span", {
    className: "ant-btn-link",
    children: originalElement
  });
}

function actionListChange(state, action) {
  var type = action.type,
      value = action.value;
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, type, value));
}

var IglooTable = function IglooTable(_ref) {
  var total = _ref.total,
      _ref$page = _ref.page,
      page = _ref$page === void 0 ? 1 : _ref$page,
      _ref$pageSize = _ref.pageSize,
      pageSize = _ref$pageSize === void 0 ? 10 : _ref$pageSize,
      _ref$pageSizeOptions = _ref.pageSizeOptions,
      pageSizeOptions = _ref$pageSizeOptions === void 0 ? [10, 20, 30, 40, 50] : _ref$pageSizeOptions,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      _ref$dataSource = _ref.dataSource,
      dataSource = _ref$dataSource === void 0 ? [] : _ref$dataSource,
      _ref$actionButtons = _ref.actionButtons,
      actionButtons = _ref$actionButtons === void 0 ? [] : _ref$actionButtons,
      className = _ref.className,
      extraButtons = _ref.extraButtons,
      _ref$filterConfig = _ref.filterConfig,
      filterConfig = _ref$filterConfig === void 0 ? {} : _ref$filterConfig,
      actionButtonsFilter = _ref.actionButtonsFilter,
      _ref$colMax = _ref.colMax,
      colMax = _ref$colMax === void 0 ? 7 : _ref$colMax,
      _ref$noCustomize = _ref.noCustomize,
      noCustomize = _ref$noCustomize === void 0 ? false : _ref$noCustomize,
      onRow = _ref.onRow,
      onClickRow = _ref.onClickRow,
      onPagination = _ref.onPagination,
      _ref$colDisable = _ref.colDisable,
      colDisable = _ref$colDisable === void 0 ? true : _ref$colDisable,
      bottomExtra = _ref.bottomExtra,
      _rowClassName = _ref.rowClassName,
      rowSelection = _ref.rowSelection,
      noPagination = _ref.noPagination,
      style = _ref.style,
      locale = _ref.locale,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _filterConfig$filterI = filterConfig.filterItems,
      filterItems = _filterConfig$filterI === void 0 ? [] : _filterConfig$filterI;

  var _useContext = useContext(LocaleContext),
      formatMessage = _useContext.formatMessage;

  var tableRef = useRef(null);

  var _useState = useState(getDefaultOptions(filterItems)),
      _useState2 = _slicedToArray(_useState, 2),
      filterOptions = _useState2[0],
      setFilterOptions = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      modalVisible = _useState4[0],
      setModalVisible = _useState4[1];

  var _useState5 = useState(filterDefaultShow(columns)),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedColKeys = _useState6[0],
      setSelectedColKeys = _useState6[1];

  var _useState7 = useState(filterDefaultShow(columns)),
      _useState8 = _slicedToArray(_useState7, 2),
      modalSelectedCol = _useState8[0],
      setModalSelectedCol = _useState8[1];

  var _useReducer = useReducer(actionListChange, {}),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      actionListVisible = _useReducer2[0],
      setActionListVisible = _useReducer2[1];

  useEffect(function () {
    if (colMax !== null && noCustomize !== true) {
      invariant(colMax >= selectedColKeys.length, 'colmax has less than default select');
    }
  }, []);
  useEffect(function () {
    var defaultKey = filterDefaultShow(columns);
    setSelectedColKeys(defaultKey);
    setModalSelectedCol(defaultKey);
  }, [JSON.stringify(columns), columns]);
  invariant(typeof onPagination === 'function', 'onPagination should be a function');
  var everyColumnsHasKey = columns.every(function (col) {
    return col.key !== undefined;
  });
  invariant(noCustomize || everyColumnsHasKey, "every column must has key value when 'noCustomize' is false");
  var hasFilterOptions = Object.keys(filterConfig).length > 0;
  columns = columns.map(function (item) {
    return _objectSpread({
      customize: true
    }, item);
  });

  var modalContent = function modalContent(options, defaultOptions, selectCallBack, colMax, colDisable) {
    return _jsx(_Checkbox.Group, {
      defaultValue: defaultOptions,
      onChange: selectCallBack,
      children: options.filter(function (item) {
        return item.customize;
      }).map(function (item) {
        return _jsx("div", {
          children: _jsx(_Checkbox, {
            value: item.key,
            disabled: colDisable && colMax ? defaultOptions.length >= colMax && !defaultOptions.includes(item.key) : false,
            children: _jsx(Typography, {
              level: "body1",
              children: item.title
            })
          })
        }, item.key);
      })
    });
  };

  var actionCol = {
    width: 50 + 32,
    title: formatMessage({
      id: 'Action'
    }),
    dataIndex: 'action',
    key: 'action',
    align: 'center',
    render: function render(text, record, index) {
      return _jsx(_Popover, {
        visible: actionListVisible[index] || false,
        onVisibleChange: function onVisibleChange(visible) {
          setActionListVisible({
            type: index,
            value: visible
          });
        },
        placement: "bottomRight",
        content: getDropDownMenu(actionButtons, record, actionButtonsFilter, setActionListVisible, index),
        getPopupContainer: function getPopupContainer() {
          return tableRef.current;
        },
        trigger: ['click'],
        title: null,
        arrowPointAtCenter: true,
        children: _jsx(DotMenuOutlined, {
          style: {
            fontSize: '24px',
            cursor: 'pointer'
          },
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          className: "igloo-table-action-icon"
        })
      });
    }
  };
  return _jsxs("div", {
    className: "igloo-table-container",
    ref: tableRef,
    style: style,
    children: [(hasFilterOptions || !noCustomize || extraButtons && extraButtons.length !== 0) && _jsxs(_Row, {
      justify: "space-between",
      gutter: [0, 24],
      className: "igloo-table-top-content",
      children: [hasFilterOptions ? _jsx(Filter, _objectSpread(_objectSpread({}, filterConfig), {}, {
        parentFilterCallBack: setFilterOptions
      })) : _jsx(_Col, {
        span: 8
      }), _jsx(_Col, {
        children: _jsxs(_Space, {
          className: 'igloo-table-button-cantainer',
          children: [!noCustomize && _jsx(Button, {
            icon: _jsx(SettingOutlined, {}),
            onClick: function onClick() {
              return setModalVisible(true);
            },
            children: _jsx(Typography, {
              level: "h4",
              children: formatMessage({
                id: 'Customize Columns'
              })
            })
          }), extraButtons && extraButtons.map(function (item, index) {
            return item.render ? /*#__PURE__*/React.cloneElement(item.render(), {
              key: index
            }) : _jsx(Button, {
              icon: item.icon,
              onClick: function onClick() {
                return item.onClick && item.onClick(filterOptions);
              },
              children: _jsx(Typography, {
                level: "h4",
                children: item.text
              })
            }, index);
          })]
        })
      })]
    }), _jsx(_Table, _objectSpread({
      className: "".concat(className || ''),
      rowClassName: function rowClassName(record, index, indent) {
        if (typeof _rowClassName === 'function') {
          return classNames(_rowClassName(record, index, indent), 'igloo-table-row');
        }

        return classNames(_rowClassName, 'igloo-table-row');
      },
      columns: actionButtons.length ? columns.filter(function (item) {
        if (selectedColKeys.includes(item.key) || !item.customize) {
          return true;
        }
      }).concat([actionCol]) : columns.filter(function (item) {
        if (selectedColKeys.includes(item.key) || !item.customize) {
          return true;
        }
      }),
      dataSource: dataSource,
      onHeaderRow: headerStyle,
      pagination: false,
      onRow: onRow || function (record, index) {
        return {
          onClick: function onClick() {
            onClickRow && onClickRow(record, index);
          }
        };
      },
      rowSelection: rowSelection ? _objectSpread(_objectSpread({}, rowSelection), {}, {
        columnWidth: 40
      }) : undefined,
      locale: _objectSpread({
        triggerDesc: formatMessage({
          id: 'Click to sort descending'
        }),
        triggerAsc: formatMessage({
          id: 'Click to sort ascending'
        }),
        cancelSort: formatMessage({
          id: 'Click to cancel sorting'
        })
      }, locale)
    }, rest)), bottomExtra, !noPagination && _jsx(_Row, {
      justify: "end",
      style: {
        marginTop: 24
      },
      children: _jsx(_Pagination, {
        itemRender: paginationItem,
        size: "small",
        current: page,
        pageSize: Number(pageSize),
        total: total,
        showSizeChanger: false,
        showTotal: function showTotal(total, range) {
          return _jsxs(_Space, {
            children: [_jsx(Typography, {
              level: "body1",
              style: {
                color: '#666666'
              },
              children: formatMessage({
                id: '{beginIndex}-{endIndex} of {total}',
                values: {
                  beginIndex: range[0],
                  endIndex: range[1],
                  total: total
                }
              })
            }), ' ', _jsx(Typography, {
              level: "body1",
              style: {
                color: '#666666'
              },
              children: formatMessage({
                id: 'Rows per page'
              })
            }), ' ', _jsx(_Select, {
              value: pageSize,
              suffixIcon: _jsx(ArrowDownOutlined, {
                style: {
                  fontSize: 24,
                  color: '#666666'
                }
              }),
              onChange: function onChange(value) {
                return onPagination(page, value);
              },
              options: pageSizeOptions.map(function (item) {
                return {
                  label: item,
                  value: item
                };
              })
            })]
          });
        },
        onChange: onPagination
      })
    }), !noCustomize && _jsxs(Modal, {
      width: 430,
      closable: true,
      destroyOnClose: true,
      visible: modalVisible,
      title: _jsx(Typography, {
        level: "h4",
        children: formatMessage({
          id: 'Customize Columns'
        })
      }),
      cancelButtonProps: {
        type: 'link',
        onClick: function onClick() {
          setModalVisible(false); // 重置一下modal选择之前的已选中列表

          setModalSelectedCol(selectedColKeys);
        }
      },
      onCancel: function onCancel() {
        setModalVisible(false); // 重置一下modal选择之前的已选中列表

        setModalSelectedCol(selectedColKeys);
      },
      okType: "default",
      onOk: function onOk() {
        setModalVisible(false);
        setSelectedColKeys(modalSelectedCol);
      },
      okText: _jsx(Typography, {
        level: "h4",
        children: formatMessage({
          id: 'Apply Columns'
        })
      }),
      children: [_jsx("div", {
        className: 'modal-describe',
        children: _jsx(Typography, {
          level: "body1",
          children: colMax === null ? '' : formatMessage({
            id: 'It is recommended to select no more than {colMax} metrics to ensure the default visibility of each column input.',
            values: {
              colMax: colMax
            }
          })
        })
      }), _jsx(Typography, {
        level: "body1",
        children: modalContent(columns, modalSelectedCol, function (item) {
          setModalSelectedCol(item);
        }, colMax, colDisable)
      })]
    })]
  });
};

export default IglooTable;